<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <SearchBlock
        :student-time-table="true"
        :prop-school-id="schoolId"
        @getSearchValue="handleSearch"
      >
      </SearchBlock>
    </div>

    <div class="table-box">
      <Table
        border
        :max-height="tableHeight - 30"
        :columns="timeTableColumn"
        :data="studentTimeTable"
        :loading="loading"
      >
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template
          v-for="(item, index) in weekList"
          :slot="'dayOfWeek' + item.value"
          slot-scope="{ row }"
        >
          <div :key="index" class="time-item-box">
            <div
              v-for="(x, y) in row['dayOfWeek' + item.value]"
              :key="y"
              class="time-item"
              @click="handleShowModal(x.classroomId)"
            >
              <span>{{ x.classroomName }}</span>
              <span>{{ x.classTimeBegin | formatTime }}-{{
                x.classTimeEnd | formatTime
              }}</span>
            </div>
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <span
            class="click-btn-430"
            @click="handleShowTimeTable(row)"
          >个人课表</span>
        </template>
      </Table>
      <Page
        :total="pageInfo.total"
        show-sizer
        show-elevator
        show-total
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <CourseDetailModal
      ref="courseDetailModal"
      :classroom-id="selectClassroomId"
      @timeTableOpen="handleToClassTable"
    ></CourseDetailModal>
    <TimeTableModal
      ref="timeTableModal"
      :person-id="personId"
      :person-name="personName"
      :year-code="searchData.yearCode"
      :term-code="searchData.termCode"
    ></TimeTableModal>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import SearchBlock from '../assets/components/SearchBlock.vue';
import CourseDetailModal from '../assets/components/CourseDetailModal.vue';
import TimeTableModal from './assets/components/TimeTableModal.vue';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { weekList } from '@/utils/dictionary.js';
import { timeToStr } from '@/utils/utils.js';
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  name: 'CourseSchedulCenterDivideClassTimeTableStudentTimeTable',
  components: {
    SearchBlock,
    CourseDetailModal,
    TimeTableModal
  },
  filters: {
    formatTime(time) {
      return timeToStr(time);
    }
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      searchData: {
        gradeId: null,
        classId: null,
        yearCode: null,
        termCode: null,
        studentName: null
      },
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      timeTableColumn: [
        key('学生ID', 'studentId', tableColumnsWidth.type4),
        key('学生姓名', 'studentName', tableColumnsWidth.type2),
        key('年级', 'gradeName', tableColumnsWidth.type2),
        key('班级', 'className', tableColumnsWidth.type2),
        slot('学校', 'schoolName', tableColumnsWidth.type6),
        slot('周一', 'dayOfWeek1', tableColumnsWidth.default),
        slot('周二', 'dayOfWeek2', tableColumnsWidth.default),
        slot('周三', 'dayOfWeek3', tableColumnsWidth.default),
        slot('周四', 'dayOfWeek4', tableColumnsWidth.default),
        slot('周五', 'dayOfWeek5', tableColumnsWidth.default),
        slot('周六', 'dayOfWeek6', tableColumnsWidth.default),
        slot('周日', 'dayOfWeek7', tableColumnsWidth.default),
        slot('操作', 'action', tableColumnsWidth.action, { fixed: 'right' })
      ],
      studentTimeTable: [],
      weekList: [...weekList],
      selectData: {},
      schoolName: '', // 学校名称
      selectClassroomId: '', // 选中的课班
      personId: '', // 选中的学生id
      personName: '', // 选中的学生姓名
      portOrg: -1, // 处于哪个端
      schoolId: '',
      loading: false
    };
  },
  computed: {
    ...mapState(['userInfo', 'schoolIdForState', 'schoolNameForState']),
    ...mapGetters(['routeTitle'])
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    // if (this.portOrg === 2) {
    //   this.getstudentTimeTableList();
    // }
    this.$nextTick(() => {
      // this.schoolId = this.portOrg === 2 ? this.userInfo.orgId : localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : '';
      this.schoolId = this.portOrg === 2 ? this.userInfo.orgId : this.schoolIdForState ? this.schoolIdForState : '';
    });
    this.schoolName = this.userInfo.orgName;
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CourseSchedulCenterDivideClassTimeTableStudentTimeTable');
    next();
  },
  activated() {
    this.$eventHub.$on('changeSchool', id => {
      console.log('eventHubchangeSchool', id);
      this.handleChangeSchool(id);
    });
    this.getstudentTimeTableList();
  },
  mounted() {
    this.$eventHub.$on('changeSchool', id => {
      console.log('eventHubchangeSchool', id);
      this.handleChangeSchool(id);
    });
  },
  destroyed() {
    this.$eventHub.$off('changeSchool');
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    handleSearch(data) {
      // this.searchData = data;
      // this.searchData.schoolId = data.schoolId ? data.schoolId : this.schoolId;
      // 回填搜索参数
      Object.keys(this.searchData).forEach(item => {
        this.searchData[item] = data[item] ? data[item] : null;
      });
      this.pageInfo.pageNum = 1;
      this.getstudentTimeTableList();
    },
    handleChangeSchool(id) {
      this.schoolId = id;
      this.pageInfo.pageNum = 1;
      this.pageInfo.total = 0;
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getstudentTimeTableList();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getstudentTimeTableList();
    },
    // 获取教师课表
    async getstudentTimeTableList() {
      const params = {
        schoolId: this.schoolId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      const paramsTrue = Object.assign(params, this.searchData);

      this.loading = true;
      const res = await courseSchedulCenter.getStudentTimeTableApi(paramsTrue);
      this.loading = false;
      if (res.status === 200) {
        this.studentTimeTable = res.message.list.map(item => {
          item.schoolName =
            this.portOrg === 2
              ? this.schoolName
              : this.schoolNameForState;
          item.timetableOfPersonVo.timetableList.forEach(x => {
            // 去重掉相同的课程
            const classroomIdObj = {};
            const courseArr = x.details.reduce((nowItem, nextItem) => {
              classroomIdObj[nextItem.classroomId]
                ? ''
                : (classroomIdObj[nextItem.classroomId] =
                  true && nowItem.push(nextItem));
              return nowItem;
            }, []);
            item[`dayOfWeek${x.dayOfWeek}`] = courseArr;
          });
          return item;
        });
        this.pageInfo.total = Number(res.message.total);
      }
    },
    // 展示弹窗
    handleShowModal(id) {
      this.selectClassroomId = id;
      this.$nextTick(() => {
        this.$refs.courseDetailModal.open();
      });
    },
    // 点击跳转到班级课表
    handleToClassTable() {
      this.$router.push({
        name:
          'courseSchedulCenter_divideClassTimeTable_studentTimeTable_classTimeTable',
        query: {
          classroomId: this.selectClassroomId,
          schoolId: this.schoolId
        }
      });
    },
    // 展示课表详情
    handleShowTimeTable(row) {
      this.personId = row.studentId;
      this.personName = row.studentName;
      this.$nextTick(() => {
        this.$refs.timeTableModal.open();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-container {
  padding: 20px;
}
.table-box {
  margin-top: 12px;
}
.time-item-box {
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .time-item {
    padding: 8px;
    border-radius: 4px;
    background: rgba(97, 73, 241, 0.1);
    color: #488ffa;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    span + span {
      margin-top: 8px;
    }
  }
  .time-item + .time-item {
    margin-top: 24px;
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
</style>
